var render = function render(){var _vm=this,_c=_vm._self._c;return _c('details-grid',{attrs:{"title":_vm.title,"header":_vm.header,"rows":_vm.rows,"max-length":_vm.width}})
}
var staticRenderFns = []

export { render, staticRenderFns }